import { Link } from "react-router-dom";

export default function ContentSection() {
  return (
    <section className="w-full bg-dark-bg py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <h1 className="text-white font-bold text-3xl md:text-4xl mb-8">
          스포츠중계
        </h1>

        <h2 className="text-white font-bold text-xl md:text-2xl mb-8 leading-relaxed">
          실시간 스포츠중계 및 무료스포츠중계 완벽 가이드: 할매티비 스포츠중계 센터
        </h2>

        <p className="text-dark-text-muted text-base leading-relaxed mb-8">
          할매티비는 실시간 <strong className="text-white">스포츠중계</strong>를 가장 빠르고 선명하게 확인할 수 있는 대한민국 대표 <strong className="text-white">스포츠중계 사이트</strong>입니다.
        </p>

        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          프리미어리그, NBA, MLB 등 전 세계 주요 경기를 한눈에 확인할 수 있는 <strong className="text-white">스포츠중계</strong> 환경을 구축하고 있으며,
          원하는 경기로 즉시 이동할 수 있는 직관적인 실시간 <strong className="text-white">스포츠중계</strong> 시스템을 제공합니다.
          고화질 인프라와 안정적인 속도를 기반으로 최상의 <strong className="text-white">무료스포츠중계</strong> 정보를 매일 업데이트하고 있습니다.
          지금 바로 <Link to="/" className="text-brand-orange hover:text-brand-orange-hover underline">실시간 스포츠중계 바로보기</Link>를 통해 모든 경기를 생생하게 확인해 보세요.
        </p>

        {/* Subsection 1 */}
        <h3 className="text-brand-orange font-bold text-lg md:text-xl mb-4">
          해외 축구 리그 및 실시간 스포츠중계 시청 전략
        </h3>
        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          EPL, 라리가, 챔피언스리그 등 인기 축구 리그는 끊김 없는 <strong className="text-white">스포츠중계</strong> 시청 환경이 무엇보다 중요합니다.
          할매티비에서는 날짜별로 큐레이션된 <strong className="text-white">스포츠중계</strong> 시간표를 통해 원하는 경기를 1초 만에 찾을 수 있습니다.
          정밀한 분석과 함께 <strong className="text-white">스포츠중계</strong>를 즐기고 싶다면
          <Link to="/live/content/livescore" className="text-brand-orange hover:text-brand-orange-hover underline"> 라이브스코어 스포츠중계</Link> 섹션을 활용해 보세요.
          실시간 데이터와 함께 최신 <strong className="text-white">무료스포츠중계</strong> 상황을 즉시 파악할 수 있습니다.
        </p>

        {/* Subsection 2 */}
        <h3 className="text-brand-orange font-bold text-lg md:text-xl mb-4">
          MLB·KBO 야구 팬들을 위한 고화질 무료스포츠중계 시스템
        </h3>
        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          야구는 투구 하나하나의 궤적을 잡는 고퀄리티 <strong className="text-white">스포츠중계</strong> 환경이 핵심입니다.
          할매티비는 지연 없는 화면 전환과 안정적인 스트리밍으로 <strong className="text-white">스포츠중계</strong> 몰입감을 극대화하며,
          야구 팬들이 선호하는 프리미엄 <strong className="text-white">무료스포츠중계</strong> 환경을 유지합니다.
          가장 빠른 전환이 필요하다면
          <Link to="/live/content/speedsportslive" className="text-brand-orange hover:text-brand-orange-hover underline"> 스피드 스포츠중계 서비스</Link> 페이지를 활용해 보세요.
        </p>

        {/* Subsection 3 */}
        <h3 className="text-brand-orange font-bold text-lg md:text-xl mb-4">
          스포츠중계 분석 필수 데이터: 실시간 라인업과 결장자 정보
        </h3>
        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          경기 결과를 정확히 예측하려면 <strong className="text-white">스포츠중계</strong> 시청 전 선수 출전 여부 확인은 필수입니다.
          할매티비의 <Link to="/live/content/todaylineup" className="text-brand-orange hover:text-brand-orange-hover underline">스포츠중계 라인업</Link>과
          <Link to="/live/content/missingplayers" className="text-brand-orange hover:text-brand-orange-hover underline"> 스포츠중계 결장자 정보</Link>는
          경기 직전의 핵심 데이터를 실시간으로 공유합니다.
          이 전문 정보를 확인하고 <strong className="text-white">스포츠중계</strong>를 시청하면 경기의 흐름과 배당의 변화를 완벽히 이해할 수 있습니다.
        </p>

        {/* Subsection 4 */}
        <h3 className="text-brand-orange font-bold text-lg md:text-xl mb-4">
          신뢰할 수 있는 무료스포츠중계 사이트 선택의 기준
        </h3>
        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          안정적인 <strong className="text-white">무료스포츠중계</strong>를 위해서는 화질, 속도, 보안성이 모두 검증되어야 합니다.
          할매티비는 PC와 모바일 어디서나 최적화된 <strong className="text-white">스포츠중계</strong> 시청 환경을 제공하며,
          불필요한 광고 없이 오직 <strong className="text-white">스포츠중계</strong>에만 집중할 수 있는 쾌적한 구조를 자랑합니다.
          모든 종목을 한눈에 보려면 <Link to="/live/content/livetv" className="text-brand-orange hover:text-brand-orange-hover underline">실시간 무료스포츠중계</Link> 메뉴를 이용해 보세요.
        </p>

        <p className="text-dark-text-muted text-base leading-relaxed mb-12">
          최고의 <strong className="text-white">스포츠중계</strong> 서비스를 가장 빠르게 만나보고 싶다면
          <Link to="/" className="text-brand-orange hover:text-brand-orange-hover underline"> 할매티비 스포츠중계 메인페이지</Link>에서 지금 바로 시청 가능합니다.
        </p>

        {/* Disclaimer */}
        <div className="border-t border-dark-border pt-8">
          <p className="text-dark-text-muted text-sm leading-relaxed">
            본 플랫폼은 전문적인 <strong className="text-white">스포츠중계</strong> 정보 제공 및 <strong className="text-white">무료스포츠중계</strong> 안내를 목적으로 운영됩니다. 전 세계 팬들을 위해 공신력 있는 데이터와 안전한 <strong className="text-white">스포츠중계</strong> 환경을 지속적으로 업데이트하겠습니다.
          </p>
        </div>
      </div>
    </section>
  );
}